<template>
    <b-modal
      id="range-university-modal"
      size="xl"
      title="Ранжированние вузов"
      @ok="onSave"
      @show="updateData"
    >
    <div class="d-flex p-1" style="height: 700px;">
      <div class="w-50 m-1 p-2 rounded-lg" style="background-color: rgb(239, 239, 239);">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-inline-block mr-2">
            <span class="mx-2">Показать вузы</span>
            <b-button variant="outline-primary" class="btn-sm" @click="setAllHidden">Скрыть все</b-button>
          </div>
          <div class="d-inline-block mr-2">        
            <span class="">Приоритет</span>
          </div>
        </div>
        
        <div class="overflow-auto" style="height: 95%;">
          <draggable v-model="formData.universitiesToShow" draggable=".item" ghost-class="ghost" :force-fallback="true" group="a">
            <div v-for="(element,index) of formData.universitiesToShow" :key="element.id" class="item p-1">
              <b-card no-body class="item-child" style="cursor:grab;">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox class="ml-2" v-model="selectedUniversitiesInShow[element.id]"></b-form-checkbox>
                    <span class="mx-2 ">{{element.title}}</span>
                  </div>
                  <b-badge variant="success" class="m-2">{{(index+1)}}</b-badge>
                </div>
              </b-card>
            </div>
          </draggable>
        </div>
        
      </div>
      <div class="text-center m-auto">
        <div class="rounded-circle arrow-button px-2 py-1 mb-4" @click="moveToHide" style="cursor: pointer;">
          <div class="fas fa-arrow-right arrow-icon"></div>
        </div>
        <div class="rounded-circle arrow-button px-2 py-1" @click="moveToShow" style="cursor: pointer;">
          <div class="fas fa-arrow-left arrow-icon"></div>
        </div>
      </div>
      <div class="w-50 m-1 p-2 rounded-lg" style="background-color: rgb(239, 239, 239);">
        <div class="d-inline-block">
          <span class="mx-2">Скрыть вузы</span>
          <b-button variant="outline-primary" class="btn-sm" @click="setAllShown">Показать все</b-button>
        </div>
        <div class="overflow-auto" style="height: 95%;">
          <draggable v-model="formData.hiddenUniversities" draggable=".item" ghost-class="ghost" :force-fallback="true" group="a">
            <div v-for="(element,index) of formData.hiddenUniversities" :key="element.id" class="item p-1">
              <b-card no-body class="item-child" style="cursor:grab;">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox class="ml-2" v-model="selectedUniversitiesInHide[element.id]"></b-form-checkbox>
                    <span class="mx-2 ">{{element.title}}</span>
                  </div>
                  <b-badge variant="danger" class="m-2">Скрыто</b-badge>
                </div>
              </b-card>
            </div>
          </draggable>
        </div>
      </div>
    </div>
    
    <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="ok()" variant="primary">
          Сохранить
        </b-button>
        <b-button variant='outline-primary' @click="cancel()"> Отмена </b-button>
      </template>
  </b-modal>
</template>

<script>
import draggable from 'vuedraggable'
import RecommendationAPI from '@/api/recommendation'

export default {
  name: 'RangeUniversitiesModal',
  components: {
    draggable
  },
  data() {
    return {
      formData: {
        universitiesToShow: [],
        hiddenUniversities: []
      },
      allUniversities: [],
      selectedUniversitiesInShow: {},
      selectedUniversitiesInHide: {},
    }
  },
  watch: {
      editData: {
        deep: true,
        async handler() {
          await this.updateData()
        }
      },
  },
  props: {
    editData: {
        type: Object,
        default: null
    },
    isEdit: {
      type: Boolean,
      default :false
    }
  },
  async created() {
    this.allUniversities = (await RecommendationAPI.getUniversities()).data;
  },
  methods: {
    onSave() {
        this.$emit('save', this.formData)
    },
    async updateData() {
      this.selectedUniversitiesInShow = _.cloneDeep({});
      this.selectedUniversitiesInHide = _.cloneDeep({});
      const hiddenUni = _.differenceBy(this.allUniversities, this.editData.universitiesToShow, 'id');
      if(this.editData.universitiesToShow) {
        this.formData.universitiesToShow = _.cloneDeep(this.editData.universitiesToShow);
        this.formData.hiddenUniversities = _.cloneDeep(hiddenUni)
      }
      else
        await this.clearData();
    },

    async clearData() {
      const partners = (await RecommendationAPI.getUniversities()).data;
      this.formData.universitiesToShow = partners;
      this.formData.hiddenUniversities = [];
    },
    setAllHidden() {
      this.formData.universitiesToShow = [];
      this.formData.hiddenUniversities = this.allUniversities;
      this.selectedUniversitiesInShow = _.cloneDeep({});
    },
    setAllShown() {
      if(this.formData.universitiesToShow.length !== this.allUniversities.length) {
        this.formData.universitiesToShow = _.cloneDeep(this.allUniversities);
        this.formData.hiddenUniversities = []
        this.selectedUniversitiesInHide = _.cloneDeep({});
      }
    },
    moveToHide() {
      const hiddenUni = _.filter(this.formData.universitiesToShow, (d) => { return this.selectedUniversitiesInShow[d.id]})
      if(hiddenUni.length !== 0) {
        this.formData.hiddenUniversities = _.union(this.formData.hiddenUniversities, _.cloneDeep(hiddenUni))
        this.formData.universitiesToShow = _.filter(this.formData.universitiesToShow, (d) => { return !this.selectedUniversitiesInShow[d.id]})
        this.selectedUniversitiesInShow = _.cloneDeep({});
      }
    },
    moveToShow() {
      const showedUni = _.filter(this.formData.hiddenUniversities, (d) => { return this.selectedUniversitiesInHide[d.id]})
      if(showedUni.length !== 0) {
        this.formData.universitiesToShow = _.union(this.formData.universitiesToShow, _.cloneDeep(showedUni))
        this.formData.hiddenUniversities = _.filter(this.formData.hiddenUniversities, (d) => { return !this.selectedUniversitiesInHide[d.id]})
        this.selectedUniversitiesInHide = _.cloneDeep({});
      }
    }
  }
}
</script>

<style scoped>
.ghost > .item-child {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

.arrow-button {
  background-color: #017ac3;
  border-radius: 25px;
}

.arrow-icon {
  font-size: 2.5rem;
  color: white
}

</style>

<style>
  div.modal .modal-dialog.modal-range {
    width: 1000px;

  }
</style>